import AWSLogo from "./aws.svg";
import CISLogo from "./cis.svg";
import CISALogo from "./cisa.svg";
import ENSLogo from "./ens.png";
import FedRAMPLogo from "./fedramp.svg";
import FFIECLogo from "./ffiec.svg";
import GDPRLogo from "./gdpr.svg";
import GxPLogo from "./gxp-aws.svg";
import HIPAALogo from "./hipaa.svg";
import ISOLogo from "./iso-27001.svg";
import MITRELogo from "./mitre-attack.svg";
import NISTLogo from "./nist.svg";
import PCILogo from "./pci-dss.svg";
import RBILogo from "./rbi.svg";
import SOC2Logo from "./soc2.svg";

export const getComplianceIcon = (complianceTitle) => {
  const name = String(complianceTitle || "").toLowerCase();
  if (name.includes("aws")) {
    return AWSLogo;
  }
  if (name.includes("cisa")) {
    return CISALogo;
  }
  if (name.includes("cis")) {
    return CISLogo;
  }
  if (name.includes("ens")) {
    return ENSLogo;
  }
  if (name.includes("ffiec")) {
    return FFIECLogo;
  }
  if (name.includes("fedramp")) {
    return FedRAMPLogo;
  }
  if (name.includes("gdpr")) {
    return GDPRLogo;
  }
  if (name.includes("gxp")) {
    return GxPLogo;
  }
  if (name.includes("hipaa")) {
    return HIPAALogo;
  }
  if (name.includes("iso")) {
    return ISOLogo;
  }
  if (name.includes("mitre")) {
    return MITRELogo;
  }
  if (name.includes("nist")) {
    return NISTLogo;
  }
  if (name.includes("pci")) {
    return PCILogo;
  }
  if (name.includes("rbi")) {
    return RBILogo;
  }
  if (name.includes("soc2")) {
    return SOC2Logo;
  }
  return AWSLogo;
}; 